import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { X } from "lucide-react";

const useStyles = makeStyles((theme) => ({
  modalOverlay: {
    position: "fixed",
    inset: 0,
    zIndex: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)"
  },
  modalContent: {
    position: "relative",
    margin: "auto",
    maxWidth: "600px",
    width: "100%"
  },
  modal: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    border: "0",
    backgroundColor: "white",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    borderRadius: "8px"
  },
  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px",
    borderBottom: "1px solid #eaeaea"
  },
  modalBody: {
    padding: "16px",
    overflowY: "auto",
    maxHeight: "400px" // Giới hạn chiều cao của body
  },
  modalFooter: {
    padding: "16px",
    borderTop: "1px solid #eaeaea"
  },
  closeButton: {
    cursor: "pointer",
    opacity: 0.8,
    "&:hover": {
      opacity: 1
    }
  }
}));

const CommonModal = ({
  open = false,
  setOpen,
  title,
  body,
  footer,
  showClose = true
}) => {
  const classes = useStyles();

  const handleCloseModal = () => {
    setOpen(false);
  };

  return (
    <>
      {open && (
        <Fragment>
          <div className={classes.modalOverlay}>
            <div className={classes.overlay} onClick={handleCloseModal}></div>
            <div className={classes.modalContent}>
              {/* Content */}
              <div className={classes.modal}>
                {/* Header */}
                {title && (
                  <div className={classes.modalHeader}>
                    <h3
                      style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}
                    >
                      {title}
                    </h3>
                    {showClose && (
                      <X
                        size={25}
                        onClick={handleCloseModal}
                        className={classes.closeButton}
                      />
                    )}
                  </div>
                )}
                {/* Body */}
                {body && <div className={classes.modalBody}>{body}</div>}
                {/* Footer */}
                {footer && <div className={classes.modalFooter}>{footer}</div>}
              </div>
            </div>
          </div>
        </Fragment>
      )}
    </>
  );
};

export default CommonModal;
